import { useCallback, useMemo } from "react";

import { refundInitiationTableColumnsConfig } from "./refundInitiationTableColumnsConfig";

import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";

export const RefundInitiationTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (refundInitiationId) => {
      navigate(`/refund_payments/${refundInitiationId}`);
    },
    [navigate]
  );
  const columnDefs = useMemo(
    () => refundInitiationTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );

  return <Table data={data} columns={columnDefs} />;
};
